<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           
            <el-card class="box-card">
                <el-table :data="footerPhotos" style="width: 100%">
                    
                    
                     <el-table-column label="image" prop="imageURL" width="80">
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="image Language">
                        <template #default="scope">
                            {{$getLanguageName(scope.row.languageID)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Operations" width="100" align="right">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit photo"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditFooterPhoto(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedFooterPhotos(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerPhotos?.list || []
        },
    },
    data(){
        return{
            footerPhotos:[],
            footerPhotoStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedFooterPhotos?.length){
            this.getAllFooterPhotos();
        }else{
            this.footerPhotos = this.cachedFooterPhotos;
          
        }
        
       
    },
    
    methods:{
       
        async getAllFooterPhotos(){
            const response = await this.$store.dispatch('getAllFooterPhotos');

            this.footerPhotos = response;
             
        },
        
      
        async handleEditFooterPhoto(footerPhoto){
            await this.$store.dispatch('storeCurrentFooterPhotoToView',footerPhoto)
            this.$router.push({
                name:'manage-footer-photo',
                params:{
                    id:footerPhoto.languageID
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>